import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import { fileIcon } from 'Helpers/File';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { noop } from 'Helpers/PropTypes';
import modalConsts from 'Consts/ModalNames';
import { addQuery } from 'Helpers/Query';
import fr from 'facet-rest';
import {
  currentFile as currentFileConst,
  files as filesConst,
} from 'Consts/Queries';
import { FILE_TYPE, FOLDER_TYPE } from 'Consts/File';
import { IconButton } from '@material-ui/core';

const FolderItem = ({
  item,
  handleNavigation,
  onMoveFileClick,
  openRenameModal,
  handleFolderHover,
  canMutate,
  handleDelete,
  breadcrumb,
  onFileClick,
  relatedFileIds,
}) => {
  const location = useLocation();
  const [resource, setResource] = useState();

  const handleFolderClick = () => {
    handleNavigation(item.id);
  };

  useEffect(() => {
    setResource(fr.resource(item));
  }, [item]);

  useEffect(() => {
    if (item.type !== 'folder') {
      handleFolderClick();
    }
  }, [location]);

  const handleFileClick = () => {
    onFileClick(item.id);
    addQuery(
      { [currentFileConst]: item.id },
      { [filesConst]: relatedFileIds.join(',') },
      { [modalConsts.modal]: modalConsts.fileViewer },
    );
  };

  const trashButton = canMutate ? (
    <IconButton
      className="button-panel-button trash-button"
      role="presentation"
      onClick={() => handleDelete(item)}
    >
      <FontAwesome icon="trash-o" />
    </IconButton>
  ) : null;

  const renameButton = canMutate ? (
    <IconButton
      className="button-panel-button folder-rename-button"
      style={{ marginTop: '1px' }} // This is due to the icon in FA having a 1px gap on the bottom.
      role="presentation"
      onClick={() => openRenameModal(item)}
    >
      <FontAwesome icon="edit" />
    </IconButton>
  ) : null;

  if (item.type === FOLDER_TYPE) {
    return (
      <div className="folder-content-container">
        <div
          className="folder-item folder-item-folder"
          role="presentation"
          onClick={() => handleFolderClick()}
          onMouseEnter={() => handleFolderHover(item.id)}
        >
          {item.attributes.unreadCount > 0 ? (
            <div className="folder-with-number">
              <FontAwesome icon="folder-o" />
              <div className="number-overlay">
                {item.attributes.unreadCount}
              </div>
            </div>
          ) : (
            <FontAwesome icon="folder-o" />
          )}
          &nbsp;
          <div className="inline">{item.attributes.name}</div>
          &nbsp;
          {breadcrumb ? null : (
            <div className="file-count-badge">{item.attributes.fileCount}</div>
          )}
        </div>
        <div className="button-panel">
          {renameButton}
          {trashButton}
        </div>
      </div>
    );
  }

  const createdOn = new Date(item.attributes.createdOn);
  const createdOnStr = `${createdOn.getMonth()
    + 1}/${createdOn.getDate()}/${createdOn.getFullYear()}`;

  if (resource === undefined) {
    return null;
  }

  if (item.type === FILE_TYPE) {
    return (
      <div className="folder-item folder-item-file" test={'folder-item-file'}>
        <div
          className="icon-and-info inline"
          onClick={() => handleFileClick()}
          role="presentation"
        >
          <FontAwesome icon={fileIcon(item.attributes.name.toLowerCase())} />
          <div className="info inline">
            <span>{resource.attr('name')}</span>
            {item.attributes.createdBy && createdOnStr !== 'NaN/NaN/NaN' ? (
              <span className="info-uploaded">
                {`Uploaded ${createdOnStr} by ${item.attributes.createdBy}`}
              </span>
            ) : null}
          </div>
        </div>
        <div className="button-panel">
          {canMutate && (
            <>
              <div
                className="button-panel-button arrow-button"
                onClick={e => onMoveFileClick(e, item)}
                role="presentation"
              >
                <FontAwesome icon="arrows" />
                Move File
              </div>
              <div
                className="button-panel-button"
                style={{ marginTop: '1px' }} // This is due to the icon in FA having a 1px gap on the bottom.
                role="presentation"
                onClick={() => openRenameModal(item)}
              >
                <FontAwesome icon="edit" />
              </div>
            </>
          )}

          {trashButton}
        </div>
      </div>
    );
  }

  return null;
};

FolderItem.propTypes = {
  handleNavigation: PropTypes.func,
  handleFolderHover: PropTypes.func,
  item: PropTypes.object.isRequired,
  openRenameModal: PropTypes.func,
  canMutate: PropTypes.bool,
  handleDelete: PropTypes.func,
  breadcrumb: PropTypes.bool,
  onFileClick: PropTypes.func,
  onMoveFileClick: PropTypes.func,
  relatedFileIds: PropTypes.array,
};

FolderItem.defaultProps = {
  handleNavigation: () => ({}),
  handleFolderHover: () => ({}),
  openRenameModal: () => ({}),
  canMutate: false,
  handleDelete: noop,
  breadcrumb: false,
  relatedFileIds: [],
  onFileClick: () => ({}),
  onMoveFileClick: () => ({}),
};

export default FolderItem;
